import { Button, Link as LinkAsButton } from 'anf-core-react';
import PropTypes from 'prop-types';
import React from 'react';
import useTranslatedText from '../../hooks/useTranslatedText';
import AppliedFacetButton from '../AppliedFacetButton';

/**
 * ClearAllButton component renders a button or link to clear all applied filters.
 *
 * @param {Object} props
 * @param {function} props.onClick - Callback function when the button is clicked.
 * @param {boolean} [props.isBordered=false] - Determines if the button should have a border style.
 * @param {boolean} [props.gridFilters=false] - If true, renders as an AppliedFacetButton.
 */
export default function ClearAllButton({ onClick, isBordered = false, gridFilters = false }) {
  const { value: clearAllText } = useTranslatedText('clearAll', { fallback: 'clear all' });
  if (gridFilters) {
    return (
      <AppliedFacetButton
        labelText={clearAllText}
        name={clearAllText}
        onClick={onClick}
      />
    );
  }
  return isBordered
    ? (
      <Button onClick={onClick} variant="tertiary-light">
        {clearAllText}
      </Button>
    )
    : (
      <LinkAsButton onClick={onClick}>
        {clearAllText}
      </LinkAsButton>
    );
}

ClearAllButton.propTypes = {
  isBordered: PropTypes.bool,
  onClick: PropTypes.func.isRequired,
  gridFilters: PropTypes.bool,
};
